import LTPlatform from "../../LTGame/Platform/LTPlatform";
import BaseUIMediator from "../../LTGame/UIExt/FGui/BaseUIMediator";
import UI_Win from "../../ui/Main/UI_Win";
import GameData from "../common/GameData";
import GlobalUnit from "../common/GlobalUnit";
import AudioManager from "../manager/AudioManager";
import LTSDK from "../../SDK/LTSDK";
import { EPlatformType } from "../../LTGame/Platform/EPlatformType";
const RateValue = [
    1.5, 2, 2.5, 3, 2.5, 2, 1.5
];
export class UI_WinMediator extends BaseUIMediator {
    static get instance() {
        if (this._instance == null) {
            this._instance = new UI_WinMediator();
            this._instance._classDefine = UI_Win;
        }
        return this._instance;
    }
    _OnShow() {
        super._OnShow();
        GlobalUnit.game.CheckShowGet();
        AudioManager.instance.PlayById(6);
        let config = GlobalUnit.game.level.config;
        this.cacheValue = GlobalUnit.game.level.config.win_reward;
        this.ui.m_btn_close.onClick(this, this.OnClose);
        this.ui.m_btn_reward.onClick(this, this.GetReward);
        this.RefreshUI();
        Laya.timer.frameLoop(1, this, this.UpdateRate);
        LTPlatform.instance.RecordEvent('game_ad_show', {
            level_id: GlobalUnit.game.level.config.id,
            id: 'win'
        });
        LTPlatform.instance.RecordEvent('game_result', { level_id: GlobalUnit.game.level.config.id, id: 'win' });
        if (GlobalUnit.game.level.config.level_type == 1) {
            GameData.instance.levelId = config.next_id;
        }
        if (!LTSDK.instance.isInCheck) {
            LTPlatform.instance.ShowInterstitalAd();
        }
        if (LTPlatform.instance.platform == EPlatformType.WX) {
            LTPlatform.instance.OpenGameBox();
        }
    }
    OnClose() {
        AudioManager.instance.PlayById(1);
        GameData.instance.coinCount += this.cacheValue;
        this.Hide();
    }
    GetReward() {
        return __awaiter(this, void 0, void 0, function* () {
            AudioManager.instance.PlayById(1);
            this.ui.m_com_rate.m_t0.setPaused(true);
            let res = yield LTPlatform.instance.ShowRewardVideoAdAsync();
            if (res) {
                LTPlatform.instance.RecordEvent('game_ad', {
                    level_id: GlobalUnit.game.level.config.id,
                    id: 'win'
                });
                GameData.instance.coinCount += this.cacheValue * this.rateValue;
                this.Hide();
                return;
            }
            this.ui.m_com_rate.m_t0.setPaused(false);
        });
    }
    RefreshUI() {
        this.ui.m_com_level.m_text_level.text = GlobalUnit.game.level.config.level_type == 1 ? "l" + GameData.instance.levelId : '';
        this.ui.m_com_coin.m_text_count.text = GameData.instance.coinCount.toString();
        this.ui.m_btn_close.m_text_count.text = this.cacheValue.toString();
    }
    UpdateRate() {
        let x = this.ui.m_com_rate.m_bar.x;
        // console.log(x);
        let width = this.ui.m_com_rate.width / RateValue.length;
        let index = Math.floor(x / width);
        this.rateValue = RateValue[index];
        this.ui.m_btn_reward.m_text_rate.text = "x" + this.rateValue;
        this.ui.m_btn_reward.m_text_count.text = (this.cacheValue * this.rateValue).toString();
    }
    _OnHide() {
        if (GlobalUnit.game.level.config.level_type > 3) {
            GlobalUnit.dataManager.UnlockLevel(GlobalUnit.game.level.config.next_id);
        }
        GameData.SaveToDisk();
        Laya.timer.clearAll(this);
        GlobalUnit.game.GoToHome();
    }
}
